import { cn } from '@/lib/utils';
import React from 'react';

interface CommandParagraphProps {
  command: string;
  className?: string;
  variant?: 'default' | 'print';
  codeClassName?: string;
  as?: 'h1' | 'h2';
}

const CommandParagraph = (props: CommandParagraphProps) => {
  const { command, className, codeClassName, as = 'h2' } = props;
  const isPrint = props.variant === 'print';

  const style = cn(
    `text-sm sm:text-base
    whitespace-pre-line break-keep font-bold
    flex-1 overflow-hidden
    text-ellipsis border-gray-500 example pl-4`,
    { 'print:text-xs': isPrint },
    className,
  );

  const codeStyle = cn(`-ml-4 first-line:ml-0`, codeClassName);

  if (as === 'h1') {
    return (
      <h1 className={style}>
        <code className={codeStyle}>{command}</code>
      </h1>
    );
  }

  return (
    <h2 className={style}>
      <code className={codeStyle}>{command}</code>
    </h2>
  );
};

export default CommandParagraph;
